export default function Badge({ text, color }) {
  return (
    <span className="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium text-gray-900 bg-white ring-2 ring-gray-300 ring-inset shadow-sm">
      <svg viewBox="0 0 6 6" aria-hidden="true" className={"size-1.5 " + color}>
        <circle r={3} cx={3} cy={3} />
      </svg>
      {text}
    </span>
  );
}
